var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M8 13.926A5.926 5.926 0 108 2.074a5.926 5.926 0 000 11.852z",
    stroke: "#386EE7",
    strokeWidth: 2.222
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.074a5.926 5.926 0 013.428 10.76",
    stroke: "#386EE7",
    strokeWidth: 2.222,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/loading.7b9c84e1.svg";
export { SvgLoading as ReactComponent };